import gql from 'graphql-tag';

export const REGIST_MY_PROFILE = gql`
    mutation ($member_no: ID!, $nickname: String, $era: Int, $score_level: Int, $profile: String) {
        registMyProfile(
          member_no: $member_no,
          nickname: $nickname,
          era: $era,
          score_level: $score_level,
          profile: $profile
        )
        {
          result
          resultText
        }
    }
`;

export const GET_MY_PROFILE = gql`
  query($member_no: ID!) {
    getMyProfile(
      member_no: $member_no
    ){
      Profile{
        era
        family_name
        given_name
        nickname
        email
        score_level
        profile
        mobile_number
        gender
      }
    }
  }
`;
